"use client";

import { useEffect, useCallback } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import recommenderService from "@/features/Recommender/services";
import { useIsLoggedIn } from "@/features/auth/services";
import profileService from "@/features/profile/service";

export default function QueryUpdater() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const isLoggedIn = useIsLoggedIn();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);
      return params.toString();
    },
    [searchParams]
  );

  useEffect(() => {
    const preload = async () => {
      const params = new URLSearchParams(searchParams.toString());
      let id = Number.isNaN(Number(params.get("u")))
        ? recommenderService.getId()
        : Number(params.get("u"));
      if (isLoggedIn) {
        const user = await profileService.getUser();
        if (user) {
          id = user.id;
        }
      } else {
        id = id ?? 1;
        id = id === 0 ? recommenderService.getId() : id;
      }
      recommenderService.setId(id);
      const newQuery = createQueryString("u", String(id));
      router.replace(`${pathname}?${newQuery}`);
    };

    preload();
  }, [pathname, isLoggedIn]);

  return null;
}
